import React from 'react'

import { useProjectT } from 'services/ProjectLabels'

import BaseButtonElement from '../BaseButtonElement'
import type { ButtonElementType } from '../buttonTypes'

interface IDefaultButtonElementProps extends React.ComponentProps<ButtonElementType> {
  children: React.ReactNode
}

const DefaultButtonElement: React.FC<IDefaultButtonElementProps> = ({
  element,
  styles,
  mode,
  font,
  children,
}) => {
  const pt = useProjectT()
  const label = element?.value?.label || pt('elements.button.common.label')

  return (
    <BaseButtonElement
      action={element.value.action}
      elementId={element.id}
      font={font}
      label={label}
      mode={mode}
      styles={styles}
    >
      {children}
    </BaseButtonElement>
  )
}

export default DefaultButtonElement
